export const buildEndpoint = (route) => {
    return process.env.NODE_ENV === 'development' ? 
        `http://api.fcc.vm:8080/${route}` :
        `https://plankton-app-aoh64.ondigitalocean.app/${route}`
} 